module.exports = "\r\n.modal-backdrop.in {\r\n    opacity: 0.9;\r\n  }\r\n  \r\n  .modal {\r\n    background-color: rgba(58, 51, 51, 0.4);\r\n    padding-top: 5px;\r\n  }\r\n  \r\n  .confirm-message {\r\n    margin-bottom: 0px;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .mt-2, .my-2 {\r\n    margin-top: -0.5rem!important;\r\n}\r\n  \r\n  .modal-footer {\r\n       border-top: none !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/prompt/alert.component.css
// module id = ./src/app/layout/prompt/alert.component.css
// module chunks = main